import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './image.scss';
import clsx from 'clsx';
import useBoolean from '../../enhancers/custom-hook/use-boolean';

const Image = React.forwardRef(({
  src, alt, onLoad, className,
}, ref) => {
  const [error, toggleError] = useBoolean(false);
  const classes = clsx('image-container', className);
  const srcRef = useRef(src);

  useEffect(() => {
    // Update previous src if there is a change in src
    if (srcRef.current !== src) {
      srcRef.current = src;
      // Reset error flag if src changed
      if (error) toggleError();
    }
  }, [toggleError, error, src]);

  if (src && !error) {
    return (
      <img
        src={src}
        className={classes}
        alt={alt}
        onLoad={onLoad}
        onError={toggleError}
      />
    );
  }

  return <div ref={ref} className={clsx(classes, { 'default-image': !className })} />;
});

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  onLoad: PropTypes.func,
  className: PropTypes.string,
};

Image.defaultProps = {
  src: '',
  alt: '',
  className: '',
  onLoad: () => {},
};

export default Image;
